<app-header titulo="BUSCAR" [mensaje]="termino"></app-header>

<div class="row mt-3 ">
    <div class="col-md-4 text-center">
        <div class="mr-1 listado-buscar">
            <div *ngIf="listado">

                <label class="fila-seleccionada">{{indices.indice + 1}}/{{listado.length}}</label>
                <ul class="list-group">
                    <li id="fila_{{ i }}" *ngFor="let producto of indices.listadoPantalla; let i=index" class="list-group-item">
                        {{ producto.nombre }}
                    </li>
                </ul>

            </div>

        </div>
    </div>
    <div class="col-md-8 text-center">
        <div class="ml-1 listado-buscar">
            <div *ngIf="info">


                <div class="row">
                    <div class="col">

                        <table class="table mt-1 fuente-tabla">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Sucursal</th>
                                    <th scope="col">Stock</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let sucursal of info.stockSucursales; let i=index">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td>{{ sucursal.nombre}}</td>
                                    <td *ngIf="sucursal.stock > 0">SI</td>
                                    <td *ngIf="sucursal.stock <= 0">NO</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <div class="col">

                        <div class="bg-dark text-white" *ngIf="info.estado == '1'">
                            <h5>Vigente</h5>
                        </div>
                        <div class="bg-danger text-white" *ngIf="info.estado == '0'">
                            <h5>No Compra</h5>
                        </div>
                        <div class="col bg-dark text-white">
                            <h5>{{ info.principio.substr(0,20) }}</h5>
                        </div>
                        <div class="col bg-dark text-white">
                            <h5>{{ info.subcategoria }}</h5>
                        </div>
                        <div class="col bg-dark text-white">
                            <h5>{{ indices.listadoPantalla[indices.fila].laboratorio }}</h5>
                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col">

                        <table class="table mt-1 fuente-tabla">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">Barra</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Venta</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let alternativa of info.alternativas; let i=index">
                                    <th scope="row">{{ alternativa.barra }}</th>
                                    <td>{{ alternativa.nombre }}</td>
                                    <td>{{ alternativa.venta }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>

        </div>
    </div>
</div>

<app-footer></app-footer>